import React, { useEffect } from "react";
import styles from "./sellerpageheader.module.css";
import facebook from "./../../assets/facebooks2.png";
import tiktok from "./../../assets/tiktoks2.png";
import user_icon from "./../../assets/account.png";
import google from "./../../assets/google2.png";
import logo from "./../../assets/logo.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { getUserMeta } from "../../apis/user";
import ImageWithFallback from "../ImageWithFallback";
import { revokeToken } from "../../apis/revokeToken";
export default function HomePageHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(["access_token", "user_info"]);
  async function handleLogout() {
    await revokeToken(cookies["access_token"]).then((res) => {
      if (res.status == 200) {
        setCookie("access_token", "", { path: "/" });
        setCookie("user_info", "", { path: "/" });
        navigate("/login");
      } else {
        console.log(res);
      }
    });
  }
  return (
    <nav className={`navbar navbar-expand-lg navbar-light ${styles.headbar}`}>
      <div className="container-fluid">
        <a href="/home" className={styles.imgTextLogo}>
          <ImageWithFallback
            loading="lazy"
            className={styles.imglogo}
            src={logo}
            alt="img-logo"
          />
          <button className={`navbar-brand ${styles.textlogo}`}>bHive</button>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a href="#" className={`nav-link ${styles.right1}`}>
                {t("help")}
              </a>
            </li>
            <li className="nav-item">
              <a href="#" className={`nav-link ${styles.right1}`}>
                {t("notification")}
              </a>
            </li>
            <li className="nav-item">
              <a onClick={handleLogout} className={`nav-link ${styles.right1}`}>
                {t("log_out")}
              </a>
            </li>
            <li className="nav-item">
              <a href="/user">
                <button className={styles.user_icon}>
                  <ImageWithFallback
                    loading="lazy"
                    src={user_icon}
                    alt="User icon"
                  />
                </button>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
